var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8418 1.83337C17.6733 1.83337 19.25 3.46504 19.25 6.26087V15.73C19.25 18.5717 17.6733 20.1667 14.8418 20.1667H7.15917C4.3725 20.1667 2.75 18.5717 2.75 15.73V6.26087C2.75 3.46504 4.3725 1.83337 7.15917 1.83337H14.8418ZM7.40667 14.4284C7.13167 14.4009 6.86583 14.5292 6.71917 14.7675C6.5725 14.9967 6.5725 15.2992 6.71917 15.5375C6.86583 15.7667 7.13167 15.9042 7.40667 15.8675H14.5933C14.9591 15.8309 15.235 15.5183 15.235 15.1525C15.235 14.7767 14.9591 14.465 14.5933 14.4284H7.40667ZM14.5933 10.2475H7.40667C7.01158 10.2475 6.69167 10.5692 6.69167 10.9634C6.69167 11.3575 7.01158 11.6784 7.40667 11.6784H14.5933C14.9875 11.6784 15.3083 11.3575 15.3083 10.9634C15.3083 10.5692 14.9875 10.2475 14.5933 10.2475ZM10.1466 6.09587H7.40667V6.10504C7.01158 6.10504 6.69167 6.42587 6.69167 6.82004C6.69167 7.21421 7.01158 7.53504 7.40667 7.53504H10.1466C10.5417 7.53504 10.8625 7.21421 10.8625 6.80996C10.8625 6.41671 10.5417 6.09587 10.1466 6.09587Z",
    fill: "#0761AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.7c1cfbdc.svg";
export { ForwardRef as ReactComponent };